import { memo } from 'react';
import { EditableCell } from './EditableCell';
import type { Project } from '@/api/client';

interface CorrectionsNumberCellProps {
  project: Project;
}

export const CorrectionsNumberCell = memo(function CorrectionsNumberCell({ project }: CorrectionsNumberCellProps) {
  const value = project.corrections_number;

  const display =
    value != null ? (
      <div className="projects-table__base-cell">
        <strong>{value}</strong>
      </div>
    ) : null;

  return (
    <EditableCell project={project} fieldKey="corrections_number">
      {display ?? <span className="projects-table__empty-value">N/A</span>}
    </EditableCell>
  );
});
